import React, { useState } from 'react';
import mascot from '../assets/hq/mascot.svg';
import { useNavigate } from 'react-router-dom';
import HamurgerDropdown from './hamburgerDropDown';
import GetStartedDrawer from './getStartedDrawer';
import hamburger from '../assets/hq/hamburger.svg';
import ConsumerDropDown from './consumerDropdown';
import GetStartedDropdown from './getStartedDropdown';

export default function NavBar({ walletRef = null }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openHam, setOpenHam] = useState(false);

  return (
    <div className='w-full flex justify-center'>
      <nav
        className='lg:bg-transparent p-3 lg:pl-6 lg:pr-3 lg:py-2 rounded-full w-[84%] lg:w-[70%] mx-auto border border-[#EBEDF0] fixed backdrop-blur-[10px]'
        style={{
          zIndex: 999,
          background:
            'linear-gradient(90deg, rgba(255, 229, 136, 0.14) 0%, rgba(188, 102, 190, 0.14) 58.93%, rgba(153, 137, 82, 0.14) 100%)',
        }}
      >
        <div className='container mx-auto flex justify-between items-center text-black text-[15px] font-semibold'>
          {/* Logo */}
          <div
            className='flex space-x-1 items-center cursor-pointer'
            onClick={() => navigate('/')}
          >
            <img
              src={mascot}
              alt=''
              className='w-[31px] h-[38px] lg:w-[40px] lg:h-[49px]'
            />
            <p className='font-bold text-[14px] lg:text-[16px]'>{'Cypher'}</p>
          </div>
          <div className='hidden lg:block'>
            <ConsumerDropDown walletRef={walletRef} />
          </div>
          <button
            className='hidden lg:block focus:outline-none text-[15px] font-semibold'
            onClick={() => navigate('/business')}
          >
            Business
          </button>
          <button
            className='hidden lg:block focus:outline-none text-[15px] font-semibold'
            onClick={() => navigate('/card')}
          >
            Cypher Card
          </button>
          {/* <button className='hidden lg:block focus:outline-none text-[15px] font-semibold'>
            About Us
          </button> */}
          <button
            className='hidden lg:block focus:outline-none'
            onClick={() => {
              window.open('https://developer.cypherwallet.io/', '_blank');
            }}
          >
            <div className='flex items-center space-x-1'>
              <p className='text-[15px] font-semibold'>{'Developers'}</p>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='11'
                height='10'
                viewBox='0 0 11 10'
                fill='none'
              >
                <path
                  d='M8.56229 2.97291L1.8496 9.68562L0.746582 8.58261L7.45928 1.8699H1.54277V0.309998H10.1222V8.88945H8.56229V2.97291Z'
                  fill='black'
                />
              </svg>
            </div>
          </button>
          <div className='flex space-x-1 items-center'>
            <div
              className='lg:hidden'
              onClick={() => setOpenHam((prev) => !prev)}
            >
              <img
                src={hamburger}
                alt=''
              />
            </div>
            <div className='hidden lg:block'>
              <GetStartedDropdown />
            </div>
            <div
              className='lg:hidden focus:outline-none bg-[#F9D26C] rounded-full p-2 lg:py-2 lg:px-3 flex items-center lg:space-x-1'
              onClick={() => {
                setOpen((prev) => !prev);
              }}
            >
              <p> Get Started </p>
            </div>
            {/* 
            <button className='focus:outline-none bg-[#F9D26C] rounded-full p-2 lg:py-2 lg:px-3 flex items-center lg:space-x-1'>
              <p className='text-[14px] font-bold lg:text-[15px] lg:font-semibold'>
                {'Get Started'}
              </p>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='25'
                height='24'
                viewBox='0 0 25 24'
                fill='none'
              >
                <path
                  d='M16.793 9.293L12.5 13.586L8.20697 9.293L6.79297 10.707L12.5 16.414L18.207 10.707L16.793 9.293Z'
                  fill='black'
                />
              </svg>
            </button> */}
          </div>
        </div>
      </nav>
      <GetStartedDrawer
        open={open}
        setOpen={setOpen}
      />
      <HamurgerDropdown
        open={openHam}
        setOpen={setOpenHam}
      />
    </div>
  );
}
